import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Picture\GetPicturesFromDossierGalleryController::__invoke
* @see app/Http/Controllers/Dossier/Picture/GetPicturesFromDossierGalleryController.php
* @route '/api/dossier/{dossier}/gallery'
*/
const GetPicturesFromDossierGalleryController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPicturesFromDossierGalleryController.url(args, options),
    method: 'get',
})

GetPicturesFromDossierGalleryController.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/gallery',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\Picture\GetPicturesFromDossierGalleryController::__invoke
* @see app/Http/Controllers/Dossier/Picture/GetPicturesFromDossierGalleryController.php
* @route '/api/dossier/{dossier}/gallery'
*/
GetPicturesFromDossierGalleryController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return GetPicturesFromDossierGalleryController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Picture\GetPicturesFromDossierGalleryController::__invoke
* @see app/Http/Controllers/Dossier/Picture/GetPicturesFromDossierGalleryController.php
* @route '/api/dossier/{dossier}/gallery'
*/
GetPicturesFromDossierGalleryController.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPicturesFromDossierGalleryController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\Picture\GetPicturesFromDossierGalleryController::__invoke
* @see app/Http/Controllers/Dossier/Picture/GetPicturesFromDossierGalleryController.php
* @route '/api/dossier/{dossier}/gallery'
*/
GetPicturesFromDossierGalleryController.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetPicturesFromDossierGalleryController.url(args, options),
    method: 'head',
})

export default GetPicturesFromDossierGalleryController